/**
 * @param query name
 * @return value | ''
 */
function getQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) {
    var value = r[2];
    // 转义特殊字符
    value = decodeURIComponent(value);

    // 检查并移除潜在的 "javascript:" 前缀
    if (value.startsWith("javascript:")) {
      value = "";
    }

    return value;
  }
  return "";
}

export default getQueryString;
